<div provide-parent-form *ngIf="playlist">
	<bb-form-element [form]="form" [label]="'TITLE' | translate" [required]="true">
		<input [(ngModel)]="playlist.title" required type="text" name="playlist-title" />
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'DESCRIPTION' | translate">
		<textarea [(ngModel)]="playlist.description" type="text" name="playlist-description"
			class="playlist-description">{{playlist.description}}</textarea>
	</bb-form-element>

	<bb-form-element
		*ngIf="playlist.listtype === 'dynamic' && playlist.allowDatasource !== 'true' && playlist.isSlideshow !== 'true'"
		[form]="form" [label]="'USE_SUGGESTS' | translate" [hasPublicationFieldOrPermission]="'suggest'"
		[helpMessage]="'HELP.USE_SUGGESTS' | translate">
		<bb-check [(ngModel)]="playlist.useSuggest" name="playlist-useSuggest" [trueValue]="'true'"
			[falseValue]="'false'" (ngModelChange)="onSuggestsChange($event)"></bb-check>
	</bb-form-element>

	<div [hasPublicationField]="'lineups'"
		*ngIf="playlist.allowDatasource !== 'true' && playlist.useSuggest !== 'true'">
		<bb-form-element [form]="form" [label]="'IS_SLIDESHOW' | translate"
			[helpMessage]="'HELP.IS_SLIDESHOW' | translate">
			<bb-check [(ngModel)]="playlist.isSlideshow" name="playlist-isSlideshow" [trueValue]="'true'"
				[falseValue]="'false'" (ngModelChange)="onIsSlideshowChange($event)"></bb-check>
		</bb-form-element>

		<bb-form-element *ngIf="playlist.isSlideshow === 'true'" [form]="form" [label]="'SLIDE_DURATION' | translate">
			<div class="slide-duration-time">
				<bb-timecode-editor [(ngModel)]="playlist.slideDuration" (ngModelChange)="onSlideDurationChange()"
					name="playlist-slideDuration" [min]="0.25"></bb-timecode-editor>
			</div>
		</bb-form-element>
	</div>

	<ng-container *ngIf="playlist?.listtype === 'dynamic'">
		<bb-form-element [disabled]="playlist.useSuggest === 'true' || playlist.isSlideshow === 'true'" [form]="form"
			[label]="'ALLOW_DYNAMIC_FILTERS' | translate" [hasPublicationFieldOrPermission]="'playlistDatasource'"
			[helpMessage]="'HELP.ALLOW_DYNAMIC_FILTERS' | translate">
			<bb-check [(ngModel)]="playlist.allowDatasource" name="playlist-allowDatasource" [trueValue]="'true'"
				[falseValue]="'false'" (ngModelChange)="filterConfigDynamic.allowDatasource = $event === 'true'">
			</bb-check>
		</bb-form-element>

		<bb-form-element *ngIf="playlist?.useSuggest === 'true'" [form]="form"
			[label]="'EXTRA_SUGGESTS_QUERY' | translate" [helpMessage]="'HELP.EXTRA_SUGGESTS_QUERY' | translate">
			<textarea [(ngModel)]="playlist.extraSuggestQuery" type="text" name="playlist-extraSuggestQuery"
				class="playlist-extraSuggestQuery"
				[placeholder]="'ENTER_SEARCHSTRING_OR_JAVASCRIPT_RETURNING_A_SEARCHSTRING' | translate">{{playlist.extraSuggestQuery}}</textarea>
		</bb-form-element>
	</ng-container>


	<hr class="divider-line">

	<!-- Dynamic (smart) list -->
	<ng-container *ngIf="playlist?.listtype === 'dynamic'">
		<h2>{{ 'FILTERS' | translate }}</h2>

		<div class="filter-type-buttons">
			<bb-button [active]="playlist.filterType === 'filters'" (click)="onFilterClick('filters')">
				<i class="fa fa-filter"></i> {{ 'FILTERS' | translate }}
			</bb-button>
			<bb-button [active]="playlist.filterType === 'solr'" (click)="onFilterClick('solr')">
				<i class="fa fa-terminal"></i> {{ 'SOLR_QUERY' | translate }}
			</bb-button>
		</div>

		<ng-container *ngIf="playlist.filterType === 'filters'">
			<p *ngIf="!playlist?.filters?.length">
				{{ 'NO_FILTERS_SELECTED' | translate }}
			</p>
			<bb-filter-set name="playlist-filters" [filterConfig]="filterConfigDynamic" [(ngModel)]="playlist.filters"
				(ngModelChange)="filterChanged.next($event)"></bb-filter-set>
		</ng-container>

		<ng-container *ngIf="playlist.filterType === 'solr'">
			<p [innerHTML]="'PLAYLIST_SWITCH_WARNING' | translate"></p>
			<textarea *ngIf="!docText" class="query-area" type="text" [(ngModel)]="playlist.query" name="playlist-query"
				(ngModelChange)="queryChanged.next($event)"></textarea>
		</ng-container>

		<ng-container *ngIf="playlist?.useSuggest !== 'true'">

			<bb-form-element [form]="form" [label]="'LIMIT_RESULTS' | translate">
				<bb-check [ngModel]="playlist.limit >= 0" name="playlist-hasLimit"
					(ngModelChange)="onUseLimitChange($event)"></bb-check>
			</bb-form-element>

			<bb-form-element *ngIf="playlist.limit >= 0" [form]="form" [label]="'LIMIT_TO' | translate">
				<input class="limit" type="number" [(ngModel)]="playlist.limit" name="playlist-limit"
					(ngModelChange)="limitChanged.next($event)" />
				<span class="text-only">{{ 'CLIPS' | translate }}</span>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'SORT_RESULTS_BY' | translate">
				<bb-select [(ngModel)]="filterSort.property" (change)="updateSort()" [options]="sortPropertyOptions"
					name="filterSort-property">
				</bb-select>
				<bb-select *ngIf="filterSort.property !== 'random'" [(ngModel)]="filterSort.direction"
					(change)="updateSort()" name="filterSort-direction">
					<option value="asc">{{ 'ASCENDING' | translate | lowercase }}</option>
					<option value="desc">{{ 'DESCENDING' | translate | lowercase }}</option>
				</bb-select>
			</bb-form-element>
		</ng-container>

		<ng-container *ngIf="playlist.filterType === 'solr'">
			<bb-solr-query-documentation></bb-solr-query-documentation>
		</ng-container>

	</ng-container>

	<!-- Static list -->
	<ng-container *ngIf="playlist?.listtype === 'static'">
		<div class="static-playlist-head">
			<h2>{{ 'ADD_CONTENT' | translate }}</h2>

			<!-- <div class="added-clips-indicator message info" ng-show="$ctrl.addedClips > 0">
			<i class="fa fa-info"></i>
			{{ 'NEW_CLIP_IN_SELECTION' | translate : {value: $ctrl.addedClips } }}
		</div> -->

			<p class="static-playlist-actions">
				{{ 'WITH_SELECTED' | translate : {value: selectedRows.length} }}:&nbsp;
				<bb-button [disabled]="selectedRows < 1" (click)="addClipsToPlaylist(selectedRows)">
					<i class="fa fa-link"></i> {{ 'ADD_TO_PLAYLIST' | translate }}
				</bb-button>
			</p>
		</div>

		<bb-filters [filterConfig]="filterConfigStatic" [lightBackground]="true"></bb-filters>

		<bb-table-container>

			<bb-table-header>
				<bb-table-header-cell class="thumb"></bb-table-header-cell>
				<bb-table-header-cell class="icon"></bb-table-header-cell>
				<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
				<bb-table-header-cell property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
				<bb-table-header-cell property="status" class="column-statusicon">&nbsp;</bb-table-header-cell>
				<bb-table-header-cell class="buttons"></bb-table-header-cell>
			</bb-table-header>

			<bb-table-row *ngFor="let row of rows" [row]="row">
				<bb-table-cell class="thumb">
					<bb-table-thumbnail [entity]="row.data"></bb-table-thumbnail>
				</bb-table-cell>
				<bb-table-cell><span style="white-space: no-break;"><span
							[innerHTML]="row.data | clipIcon"></span><strong
							[hidden]="row.data.usetype !== 'commercial'" style="padding: 3px; color: #f8b32a;"
							title="Creative">C</strong></span></bb-table-cell>
				<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
				<bb-table-cell property="title" class="overflow">
					<span [hidden]="!row?.data?.title">{{ row.data.title }}</span>
					<span [hidden]="row?.data?.title" class="filename">{{ row.data.originalfilename }}</span>
				</bb-table-cell>
				<bb-table-cell property="status" class="column-statusicon">
					<div [innerHtml]="row.data | statusIcon"></div>
				</bb-table-cell>
				<bb-table-cell class="buttons">
					<a class="button" (click)="linkItem(row)">
						<i class="fa fa-link"></i>
					</a>
					<a class="button" (click)="showPreview(row.data)">
						<i class="fa fa-eye"></i>
					</a>
				</bb-table-cell>
			</bb-table-row>
		</bb-table-container>

		<bb-table-pager></bb-table-pager>
	</ng-container>
</div>
